import { useEffect, useState } from "react";
import { Border } from "./style";
import {
  BiConversation,
  BiGroup,
  BiPhone,
  BiSolidConversation,
  BiSolidGroup,
  BiSolidPhone,
} from "react-icons/bi";
import axios from "axios";

interface ChatNavProps {
  onChatClick: () => void;
  onContactsClick: () => void;
  onCallLogsClick: () => void;
  onMyProfileClick: () => void;
}

const ChatNav = ({
  onChatClick,
  onContactsClick,
  onCallLogsClick,
  onMyProfileClick,
}: ChatNavProps) => {
  const [activeIcon, setActiveIcon] = useState("chat");
  const storedToken = sessionStorage.getItem("token");
  const token = `Bearer ${storedToken}`;
  const [avatar, setAvatar] = useState("");

  const Authorization = {
    Authorization: token,
    "Content-Type": "application/json",
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_ENDPOINT}/getme`, {
        headers: Authorization,
      })
      .then((res: any) => {
        if (res.data.result.image !== "") {
          setAvatar(res.data.result.image);
        }
      })
      .catch((err) => {});
  }, []);

  return (
    <div>
      <Border>
        <div
          onClick={() => {
            onChatClick();
            setActiveIcon("chat");
          }}
        >
          {activeIcon === "chat" ? (
            <BiSolidConversation size={22} color="#000" />
          ) : (
            <BiConversation size={22} color="#000000b9" />
          )}
          <span style={{ color: activeIcon === "chat" ? "#000" : "" }}>
            chat
          </span>
        </div>
        <div
          onClick={() => {
            onContactsClick();
            setActiveIcon("contacts");
          }}
        >
          {activeIcon === "contacts" ? (
            <BiSolidGroup size={22} color="#000" />
          ) : (
            <BiGroup size={22} color="#000000b9" />
          )}
          <span style={{ color: activeIcon === "contacts" ? "#000" : "" }}>
            contacts
          </span>
        </div>
        <div
          onClick={() => {
            onCallLogsClick();
            setActiveIcon("callLogs");
          }}
        >
          {activeIcon === "callLogs" ? (
            <BiSolidPhone size={22} color="#000" />
          ) : (
            <BiPhone size={22} color="#000000b9" />
          )}
          <span style={{ color: activeIcon === "callLogs" ? "#000" : "" }}>
            call logs
          </span>
        </div>
        <div
          onClick={() => {
            onMyProfileClick();
            setActiveIcon("myProfile");
          }}
        >
          <img
            src={avatar || "image/user101.png"}
            alt="Avatar"
            style={{
              border: activeIcon === "myProfile" ? "1px solid #000" : "",
            }}
          />
          <span style={{ color: activeIcon === "myProfile" ? "#000" : "" }}>
            Profile
          </span>
        </div>
      </Border>
    </div>
  );
};

export default ChatNav;
